import { render, staticRenderFns } from "./_NewArrivalsButton.vue?vue&type=template&id=39a8c55e&"
import script from "./_NewArrivalsButton.vue?vue&type=script&lang=js&"
export * from "./_NewArrivalsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports